import apisauce from 'apisauce';

// constructor
const create = (baseURL = window.API_HOST) => {
    const api = apisauce.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 10000,
    });

    const search = (keyword, type, pageNum = 1, pageSize = 20) => {
        const typeParams = (type && type != 'all') ? {
          type: type.replace(/ /gi, ''),
        } : {}

        return api.get(window.SEARCH_API + 'catalogs/query', {
            ...typeParams,
            key: keyword,
            pageSize,
            pageNum,
            extendHit: true
        });
    };

    const searchStat = (keyword, pageNum = 1, pageSize = 1) => {
        return api.get(window.SEARCH_API + 'catalogs/query', {
            key: keyword,
            pageSize,
            pageNum
        });
    };

    return {
        search,
        searchStat
    };
};


export default {
    create,
};
